export default {
	DeclarationSubmit: 'Nộp tờ khai',
	TaxPeriod: 'Kỳ tính thuế',
	DeclarationType: 'Loại tờ khai',
	Times: 'Lần nộp',
	SelectedOtherDeclaration: 'Chọn tệp tờ khai khác',
	Appendix: 'Phụ lục',
	SelectFileFormComputed: 'Chọn tệp từ máy tính',
	AddAppendix: 'Thêm phụ lục',
	NoteUploadAppendix:
		'Chấp nhận file doc, docx, xls, xlsx dung lượng tối đa 5MB',
	FisrtTimes: 'Lần đầu',
	AddMore: value => `Bổ sung lần ${value}`,
	PleaseImportFileIndividual: 'Vui lòng chọn tệp trước khi nộp tờ khai cho Cơ quan thuế.',
	PleaseImportFile: 'Vui lòng chọn tệp trước khi ký và nộp.',
	ErrorTypeAppendixFile:
		'Vui lòng chọn tệp có định dang DOC, DOCX, XLS, XLSX',
	DragAndDropOr: 'Kéo và thả tệp tờ khai vào đây hoặc',
	SelectedFile: 'Chọn tệp',
	FromComputed: 'từ máy tính',
	AcceptLower5MB: '* Chấp nhận file XML, dung lượng tối đa 5MB',
	AcceptImageLower5MB:
		'* Chấp nhận file jpg, png, jpeg dung lượng tối đa 5MB',
	DragAndDropToUpload: 'Kéo thả file để upload',
	ErrorMoreThan5MB: 'Vui lòng chọn tệp có dung lượng nhỏ hơn 5MB',
	ErrorTypeFileXML: 'Vui lòng chọn tệp có định dạng XML',
	ErrorTypeFileIMGPDF: 'Vui lòng chọn tệp có định dạng PNG/JPG/PDF/JPEG',
	Cancel: 'Hủy bỏ',
	SignAndSubmit: 'Ký và gửi',
	SubmitIndividual: 'Gửi tờ khai',
	DeclarationSuccess: 'Nộp tờ khai thuế thành công',
	SendAppendix: 'Gửi phụ lục',
	PleaseSelectAppendix: 'Vui lòng chọn phụ lục và tệp trước khi ký và nộp.',
	PleaseImportFileAppendix: 'Vui lòng chọn tệp trước khi ký và nộp.',
	WarningWaitingTCT:
		'Tờ khai đang chờ TCT phê duyệt nên không được nộp phụ lục',
	WarningRegister: 'Tờ khai chưa đăng ký nộp qua mạng. Vui lòng đăng ký nộp',
	WarningRegisterHaunt:
		'Tờ khai chưa đăng ký địa bàn vãng lai. Vui lòng đăng ký nộp',
	ButtionShowRegister: 'tại đây',
	CompleteExplanation: 'Đã hoành thành giải trình, bổ sung',
	SubmitFullAttachment: 'Đã nộp đủ hồ sơ đính kèm',
	MissFileAppendix:
		'Bạn chưa đính kèm tệp phụ lục đã chọn. Bạn có muốn tiếp tục?',
	SelectMinAppendix: 'Bạn cần phải chọn ít nhất 1 phụ lục',
	UploadMinAppendix: 'Bạn cần đính kèm ít nhất 1 phụ lục đã chọn',
	Note: '*Lưu ý:',
	WarningVerion: value =>
		`Tờ khai đang nộp có phiên bản XML cũ. Để tránh phát sinh lỗi khi nộp, bạn nên sử dụng phiên bản XML từ HTKK ${value} trở lên.`,
	AdminProcedure: 'Thủ tục hành chính',
	OriginalTransCode: 'Mã giao dịch của TCT/mã hồ sơ tờ khai chính thức',
	OriginalTransCodeTooltip: 'Vui lòng truy cập hệ thống đã sử dụng để nộp tờ khai chính thức (ví dụ: Cổng Dịch vụ công), tra cứu và lấy Mã giao dịch/Mã hồ sơ đã được chấp nhận. Sau đó nhập vào đây trước khi "Ký và gửi" tờ khai.',
	OriginalTransCodePlaceholder: 'Nhập mã giao dịch tờ khai gốc',
	AppendixDocument: 'Phụ lục/Tài liệu đính kèm',
	NoteUploadAppendixDoc: 'Chấp nhận file doc, docx, xls, xlsx dung lượng tối đa 5MB',
	NoteUploadAppendixXml: 'Chấp nhận file xml dung lượng tối đa 5MB',
	NoteUploadAppendixAll: 'Chấp nhận file doc, docx, xls, xlsx, xml dung lượng tối đa 5MB',
	NoteUploadAppendixFormats: (formats) => `Chấp nhận file ${formats} dung lượng tối đa 5MB`,
	ErrorXmlMaTkhaiNotMatch: (maTkhaiXml, maBangKe) => `File XML có mã tờ khai (${maTkhaiXml}) không khớp với mã tài liệu đính kèm đang chọn (${maBangKe})`,
	ErrorXmlMaTkhaiNotFound: 'Không tìm thấy mã tờ khai trong file XML',
};
